import { createContext, useContext } from 'react'
import type { GroupOption, ReportOption, UserOption, UserRow, UserGroupRow } from '../types/users'

export type UserManagementContextValue = {
  clientId: string
  users: UserRow[]
  userGroups: UserGroupRow[]
  groupOptions: GroupOption[]
  reportOptions: ReportOption[]
  bulkInviteOptions: UserOption[]
  org2FA: boolean
  userSearch: string
  setUserSearch: (value: string) => void
  hideInactiveUsers: boolean
  setHideInactiveUsers: (value: boolean) => void
  userGroupSearch: string
  setUserGroupSearch: (value: string) => void
  usersLoading: boolean
  usersFetching: boolean
  usersError: boolean
  usersErrorObject: unknown
  groupsLoading: boolean
  groupsFetching: boolean
  groupsError: boolean
  groupsErrorObject: unknown
  refetchUsers: () => Promise<unknown>
  refetchGroups: () => Promise<unknown>
}

export const UserManagementContext = createContext<UserManagementContextValue | null>(null)

export function useUserManagementContext() {
  const context = useContext(UserManagementContext)
  if (!context) {
    throw new Error('useUserManagementContext must be used within UserManagementProvider')
  }
  return context
}
